import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';
const testimonials = [{
  name: 'Josefina M.',
  avatar: 'https://cdn.magicpatterns.com/uploads/9y4cC7apG7wDK5YYbaxx9T/landing_avatar_3.png',
  text: 'Che, la verdad que no esperaba que fuera tan completo. Pensé que iba a ser uno de esos PDF con recetas genéricas de internet y no, tiene todo explicado bien clarito. Ya hice las milanesas y las papas tres veces esta semana jajaja'
}, {
  name: 'Natalia B.',
  avatar: 'https://cdn.magicpatterns.com/uploads/3Q7oz4bNrVx2CqhWyDc7yR/6.png',
  text: 'Lo compré medio desconfiada la verdad, pero me decidí y re valió la pena. Lo que más me gustó es que pone los tiempos exactos porque siempre me quedaba todo seco. Ahora el pollo sale jugoso y mis hijos me lo piden seguido.'
}, {
  name: 'Martina V.',
  avatar: 'https://cdn.magicpatterns.com/uploads/b5Q8e5JPrk3mXDgsgqs22D/head-shot-happy-beautiful-young-woman-posing-indoors-looking-camera-smiling.jpg',
  text: 'Tenía la freidora hace 8 meses en una caja sin abrir porque no sabía bien cómo usarla. La saqué por este libro y ahora cocino todos los días. Las empanadas son un chiste de fáciles, quedan re doraditas.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function TestimonialsSection() {
  return <section className="w-full py-12 md:py-20 px-6 bg-background" data-id="element-434">
      <div className="max-w-[900px] mx-auto" data-id="element-435">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-3xl md:text-4xl font-serif mb-12 text-center text-charcoal" data-id="element-436">
          Lo que dicen quienes ya lo tienen
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-437">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-6 shadow-soft flex flex-col h-full border border-surface" data-id="element-438">
              <div className="flex items-center gap-1 mb-4 text-yellow-400" data-id="element-439">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-440" />)}
              </div>

              <p className="text-charcoal/80 text-base leading-relaxed mb-6 flex-grow italic" data-id="element-441">
                "{testimonial.text}"
              </p>

              <div className="mt-auto flex items-center gap-3" data-id="element-442">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover flex-shrink-0" data-id="element-443" />
                <div data-id="element-444">
                  <p className="font-bold text-charcoal mb-1" data-id="element-445">
                    {testimonial.name}
                  </p>
                  <div className="inline-flex items-center gap-1.5 bg-verified-bg text-verified-text px-2.5 py-1 rounded-full text-xs font-medium" data-id="element-446">
                    <CheckCircle className="w-3 h-3" data-id="element-447" />
                    Compradora verificada
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-448">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          window.location.href = 'https://valordigital.store/cart/46518849142973:1';
        }} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-8 rounded-xl shadow-soft transition-colors text-base" data-id="element-449">
            Quiero probarlo yo también →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}